import PageviewIcon from '@material-ui/icons/Pageview';
import {
    CustomBreadcrumbs,
    CustomList,
    CustomFilter,
} from 'candy-commons-components';
import { TextField, useTranslate, TextInput } from 'react-admin';
import DynamoPagination from '../../../components/DynamoPagination';
import CustomDatagrid from '../../../components/organisms/customDatagrid';
import React from 'react';

const DiscoverCategoriesFilter = (props) => (
    <CustomFilter {...props}>
        <TextInput
            label="resources.discover-categories.fields.search"
            source="q"
            alwaysOn
        />
    </CustomFilter>
);
const DiscoverCategoriesList = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.discover-categories.name'),
            url: '',
            icon: <PageviewIcon />,
        },
    ];

    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <CustomList
                // filters={<DiscoverTagsFilter />}
                perPage={25}
                exporter={false}
                {...props}
                bulkActionButtons={
                    permissions &&
                    permissions['discover-categories'] &&
                    permissions['discover-categories'].delete
                }
                pagination={<DynamoPagination resource="discoverCategories" />}
            >
                <CustomDatagrid selectable rowClick="edit">
                    <TextField source="categoryName" />
                    <TextField source="categoryKey" />
                </CustomDatagrid>
            </CustomList>
        </>
    );
};

export default DiscoverCategoriesList;
